import React from 'react'

const TranslateIcon = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='36'
      height='36'
      viewBox='0 0 36 36'
      xmlns='http://www.w3.org/2000/svg'
      {...props}
    >
      <path
        d='M17.8914 25.2399L21.1855 16.5521H22.7059L26 25.2399H24.4796L23.7014 23.0317H20.19L19.4118 25.2399H17.8914ZM12.1719 23.0679L11.1584 22.0544L14.8145 18.3983C14.3922 17.9759 14.009 17.4933 13.6652 16.9503C13.3213 16.4073 13.0045 15.7919 12.7149 15.1041H14.2353C14.4766 15.5747 14.7179 15.985 14.9593 16.3349C15.2006 16.6848 15.4902 17.0348 15.8281 17.3847C16.2262 16.9865 16.6395 16.4284 17.0679 15.7105C17.4962 14.9925 17.819 14.3078 18.0362 13.6562H10V12.2082H15.0679V10.7603H16.5158V12.2082H21.5837V13.6562H19.4842C19.2308 14.525 18.8507 15.4179 18.3439 16.3349C17.8371 17.252 17.3363 17.9518 16.8416 18.4345L18.5792 20.2082L18.0362 21.6924L15.8281 19.4299L12.1719 23.0679ZM20.6425 21.7648H23.2489L21.9457 18.0725L20.6425 21.7648Z'
        fill='currentcolor'
      />
    </svg>
  )
}

export default TranslateIcon
